import React from 'react';
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from "@material-ui/core/styles";
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import CheckCircleWhite from '../../../icons/check-circle-white.svg';
import SvgIcon from '@material-ui/core/SvgIcon';


function FancyButton(props) {

  const useStyles = makeStyles((theme) => ({
    styledButton: {
      height: '56px',
      boxShadow: '0 2px 5px 0 rgb(0,0,0,0.2)',
      textTransform: 'none',
    },
    styledButtonError: {
      border: '1px solid red !important',
    },
    styledButtonInactive: {
      border: 'none',
    },
    styledIcon: {
      marginLeft: 'auto',
    },
    styledLabel: {
      marginRight: 'auto',
      color: '#4c4c4c',
      fontFamily: 'museo-sans',
      fontWeight: 700
    },
    styledLabelSelected: {
      marginRight: 'auto',
      color: theme.palette.primary.main,
      fontFamily: 'museo-sans',
      fontWeight: 700
    },
    styledCheck: {
      marginLeft: 'auto',
    },
    whiteBackground: {
      backgroundColor: "white",
    },
    marginLeftClass: {
      marginLeft: '1rem',
      "@media (max-width: 425px)": {
        marginLeft: '0px',
      }
    },
    marginRightClass: {
      marginRight: '0.5rem',
      "@media (max-width: 425px)": {
        marginRight: '0px'
      }
    }
  }));

  const classes = useStyles();

  const buttonClasses = `${classes.styledButton} ${(props.active ? classes.styledButtonActive : classes.styledButtonInactive)} ${(props.error ? classes.styledButtonError : '')} ${props.isWhiteBackground ? classes.whiteBackground : ''}`;

  const blankIcon = props.isBlankIcon ? <SvgIcon component={CheckCircleWhite} className={classes.marginLeftClass} /> : <CheckCircleIcon className={classes.marginLeftClass} htmlColor='#bbb' />;

  return (
    <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true">
      {props.icon && <div className={`${classes.styledIcon} ${classes.marginRightClass}`}>{props.icon}</div>}
      <div className={ props.active ? classes.styledLabelSelected : classes.styledLabel}>{props.label}</div>
      {!props.isBlankCheckMark && <div className={classes.styledCheck}> {props.active ? <CheckCircleIcon className={classes.marginLeftClass} color="primary" /> : blankIcon} </div>}
    </Button>
  )
}

export default function StyledRadioInput(props) {

  const useStyles = makeStyles(() => ({
    label: {
      color: 'rgba(0, 0, 0, 0.54)',
      padding: '0',
      fontSize: '1rem',
      fontFamily: '"museo-sans", "Helvetica", "Arial", sans-serif',
      fontWeight: '400',
      lineHeight: '1',
    }
  }));

  const classes = useStyles();

  return (
    <div>
      {props.label && <legend className={classes.label}>{props.label}</legend>}
      <Row className='radio-input'>
        <Col xs={6} className="ppr-6">
          <Form.Group>
            <FancyButton
              active={props.value === props.options[0].value}
              icon={props.options[0].icon}
              label={props.options[0].label}
              onClick={() => props.onChange(props.options[0].value)}
              error={!!props.errors}
              isBlankIcon={props.isBlankIcon}
              isBlankCheckMark={props.isBlankCheckMark}
              isWhiteBackground={props.isWhiteBackground}
              id={props.id}
            />
          </Form.Group>
        </Col>
        <Col xs={6} className="ppl-6">
          <Form.Group>
            <FancyButton
              active={props.value === props.options[1].value}
              icon={props.options[1].icon}
              label={props.options[1].label}
              onClick={() => props.onChange(props.options[1].value)}
              error={!!props.errors}
              isBlankIcon={props.isBlankIcon}
              isBlankCheckMark={props.isBlankCheckMark}
              isWhiteBackground={props.isWhiteBackground}
            />
          </Form.Group>
        </Col>
        {props.errors && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block">{props.errors.message}</span>}
      </Row>
    </div>
  )
}

StyledRadioInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  value: PropTypes.string.isRequired,
  isBlankIcon: PropTypes.bool,
  isBlankCheckMark: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.object,
  })),
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/StyledRadioInput.js